import _objectSpread from "/Users/begin/work/boss-react/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/objectSpread";
export default {
  namespace: "bi1501Info",
  state: {
    dataSource: [],
    agencyGroupList: [],
    ipGroupData: [],
    portGroupData: []
  },
  reducers: {
    update: function update(state, action) {
      return _objectSpread({}, state, action.payload);
    }
  }
};